import { Injectable } from '@angular/core';

export type TappName = 'Vendor Manager' | 'Business Manager' | 'Delivery Manager' | 'Market Place';

@Injectable({
  providedIn: 'root'
})
export class AppNameService {
  appName?: TappName;
  name = 'Eagle Info Solutions';
}

